const customAddToCart = async function (event, preorderDate, productHandle) {
  // TH 5/29/26 - Scope variant/qty/button resolution to the FIRING form, not document-global.
  // Multiple product forms can share a page (e.g. rid-featured-product on page templates);
  // global selectors returned the first form's values and added the wrong variant. Fall back
  // to document-global when the firing form can't be resolved so single-form PDPs are unaffected.
  const form = event.target.closest(".product-form");
  const atcButton = event.target.closest("[data-product-add-to-cart-button]") || event.target;
  setAddToCartButtonState(true, atcButton);
  if (productHandle == "boundless-bandana") {
    try {
      const selectedBuyOption = form.getAttribute("data-selected-buy-option") || '1';
      if (!selectedBuyOption) throw new Error("Please select a buy option");
      // Get cart count for bundle ID
      const cartResult = await fetch(`${window.themeVariables.routes.cartUrl}.js`);
      const cart = await cartResult.json();
      let bundleCount = 0;
      if (cart && cart.items && Array.isArray(cart.items)) {
        bundleCount = cart.items.filter((item) => item.handle === "boundless-bandana").length;
      }
      let itemsToAdd = [];
      if (selectedBuyOption === "1") {
        const variantIdElement = (form || document).querySelector("input[name='id']");
        const variantId = variantIdElement ? variantIdElement.value : null;
        const quantityElement = (form || document).querySelector("input[name='quantity']");
        const quantity = quantityElement ? quantityElement.value || 1 : 1;
        bundleCount++;
        itemsToAdd.push({
          quantity: quantity,
          id: variantId,
          properties: {
            "_bandana-bundle-id": String(bundleCount),
            ...(preorderDate ? { "_preorder-date": preorderDate } : {}),
          },
        });
      } else {
        const selectedVariantIds = [];
        const variantSelectors = document.querySelectorAll(
          `.variant-selectors[data-buy-option="${selectedBuyOption}"] .variant-selector`
        );
        variantSelectors.forEach((selector) => {
          const variantId = selector.getAttribute("data-selected-variant-id");
          if (variantId) selectedVariantIds.push(variantId);
        });
        const expectedVariantCount = parseInt(selectedBuyOption);
        if (selectedVariantIds.length !== expectedVariantCount) {
          throw new Error(
            `Please select ${expectedVariantCount} bandana${expectedVariantCount > 1 ? "s" : ""}`
          );
        }
        selectedVariantIds.forEach((variantId) => {
          bundleCount++;
          itemsToAdd.push({
            quantity: 1,
            id: variantId,
            properties: {
              "_bandana-bundle-id": String(bundleCount),
              ...(preorderDate ? { "_preorder-date": preorderDate } : {}),
            },
          });
        });
      }
      for (const item of itemsToAdd) {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(item),
        });
        if (!response.ok) {
          const responseJson = await response.json();
          throw new Error(responseJson["description"] || "Failed to add item to cart");
        }
      }
      await updateCartAndNotify(true);
    } catch (error) {
      await updateCartAndNotify(false, error.message);
    } finally {
      setAddToCartButtonState(false, atcButton);
    }
  } else {
    try {
      const variantIdElement = (form || document).querySelector("input[name='id']");
      const variantId = variantIdElement ? variantIdElement.value : null;
      const quantityElement = (form || document).querySelector("input[name='quantity']");
      const quantity = quantityElement ? quantityElement.value || 1 : 1;
      const mainProperties = preorderDate ? { "_preorder-date": preorderDate } : {};

      // Keep the main product first: the variant:added dispatch below reads items[0].
      const upsellItems = collectPdpUpsellItems(form || document);

      let body;
      if (upsellItems.length > 0) {
        body = {
          items: [{ id: variantId, quantity: quantity, properties: mainProperties }, ...upsellItems],
        };
      } else {
        body = { quantity: quantity, id: variantId };
        if (preorderDate) {
          body.properties = mainProperties;
        }
      }
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const responseJson = await response.json();
      await updateCartAndNotify(response.ok, responseJson["description"] || "", responseJson);
      if (response.ok) {
        document.documentElement.dispatchEvent(
          new CustomEvent("variant:added", {
            bubbles: true,
            detail: {
              variant: responseJson.hasOwnProperty("items")
                ? responseJson["items"][0]
                : responseJson,
            },
          })
        );
      }
    } catch (error) {
      await updateCartAndNotify(false, error.message);
    } finally {
      setAddToCartButtonState(false, atcButton);
    }
  }
};

function collectPdpUpsellItems(scope) {
  const root = scope || document;
  const upsellItems = [];
  root.querySelectorAll("[data-pdp-upsell]").forEach((card) => {
    const cardCheckbox = card.querySelector("[data-pdp-upsell-checkbox]");
    const cardVariantInput = card.querySelector("[data-pdp-upsell-variant-id]");
    const cardVariantId = cardVariantInput ? cardVariantInput.value : null;
    const cardUpsellKey = card.getAttribute("data-pdp-upsell-key");
    if (cardCheckbox && cardCheckbox.checked && cardVariantId) {
      upsellItems.push({
        id: cardVariantId,
        quantity: 1,
        properties: { "_pdp-upsell": cardUpsellKey || "true" },
      });
    }
  });
  return upsellItems;
}

const customIdBuilderRedirect = function (event, builderUrl) {
  event.preventDefault();
  let url = builderUrl;
  try {
    const form = event.target.closest(".product-form") || document;
    let upsellItems = collectPdpUpsellItems(form);
    if (upsellItems.length === 0 && form !== document) {
      upsellItems = collectPdpUpsellItems(document);
    }
    if (upsellItems.length > 0) {
      const ids = upsellItems.map((item) => item.id).join(",");
      url += (url.indexOf("?") === -1 ? "?" : "&") + "addon_variant_ids=" + encodeURIComponent(ids);
    }
  } catch (error) {
    console.error("[pdp-upsell] failed to append upsell to builder URL:", error);
  } finally {
    window.location.href = url;
  }
};

// Helper to set Add to Cart button state
// TH 5/29/26 - Accept the firing button so multi-form pages toggle the correct one;
// fall back to the global #AddToCart lookup for any legacy caller that omits it.
function setAddToCartButtonState(loading, button) {
  const addToCartButton = button || document.getElementById("AddToCart");
  if (!addToCartButton) return;
  if (loading) {
    addToCartButton.setAttribute("disabled", "true");
    addToCartButton.setAttribute("aria-busy", "true");
  } else {
    addToCartButton.removeAttribute("disabled");
    addToCartButton.setAttribute("aria-busy", "false");
  }
}

// Helper to update cart and dispatch events
async function updateCartAndNotify(success, errorMsg, responseJson) {
  if (success) {
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }
    // Refresh cart and dispatch events
    const cartResponse = await fetch(
      `${window.themeVariables.routes.cartUrl}.js`
    );
    const cartContent = await cartResponse.json();
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:updated", {
        bubbles: true,
        detail: { cart: cartContent },
      })
    );
    if (responseJson && responseJson["sections"]) {
      cartContent["sections"] = responseJson["sections"];
    }
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartContent,
          openMiniCart: window.themeVariables.settings.cartType === "drawer",
        },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: "success",
          error: "",
        },
      })
    );
  } else {
    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: "error",
          error: errorMsg,
        },
      })
    );
  }
}

var DidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("did-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }
  // Move to previous products (if any)
  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  // Move to next products (if any)
  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(DidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("did-product-list", DidProductList);

var DidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );
    this.delegate.on(
      "mouseenter",
      ".product-item-meta__swatch-list .color-swatch__item",
      this._onColorSwatchHovered.bind(this),
      true
    );
    this.delegate.on(
      "mouseenter",
      ".product-item-meta__swatch-list .block-swatch__item",
      this._onColorSwatchHovered.bind(this),
      true
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__item",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__item",
      this._onColorSwatchChanged.bind(this)
    );
  }

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );

          Array.from(
            swatchGroup.querySelectorAll(".color-swatch__item")
          ).forEach((swatch) => {
            swatch.classList.remove("is-selected");
          });
          target.classList.add("is-selected");
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );
    let matchingVariant = null;

    matchingVariant = variants.find(function (variant) {
      return (
        variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
        variant.option2 === selectedValues[Object.keys(selectedValues)[1]] &&
        variant.option3 === selectedValues[Object.keys(selectedValues)[2]]
      );
    });

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]] &&
          variant.option2 === selectedValues[Object.keys(selectedValues)[1]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants.find(function (variant) {
        return (
          variant.option1 === selectedValues[Object.keys(selectedValues)[0]]
        );
      });
    }

    if (!matchingVariant) {
      matchingVariant = variants[0];
    }

    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });
    if (target.hasAttribute("data-upsell-item")) {
      updateUpsellInfoWithProductAndVariantId(this.id, matchingVariantId);
    }
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find((image) => {
        const variantId = image.getAttribute("data-variant-id");

        return variantId === matchingVariantId.toString();
      });
      newImage.setAttribute("loading", "eager");
      const onImageLoaded = newImage.complete
        ? Promise.resolve()
        : new Promise((resolve) => (newImage.onload = resolve));
      await onImageLoaded;
      newImage.removeAttribute("hidden");
      let properties = {};
      if (
        Array.from(newImage.parentElement.classList).some((item) =>
          [
            "aspect-ratio--short",
            "aspect-ratio--tall",
            "aspect-ratio--square",
          ].includes(item)
        )
      ) {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translate(calc(-50% - 20px), -50%)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            offset: 1,
          },
        ];
      } else {
        properties = [
          {
            clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0,
          },
          {
            clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
            transform: "translateX(-20px)",
            zIndex: 1,
            offset: 0.3,
          },
          {
            clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
            transform: "translateX(0px)",
            zIndex: 1,
            offset: 1,
          },
        ];
      }
      await newImage.animate(properties, {
        duration: 500,
        easing: "ease-in-out",
      }).finished;
      this.primaryImageList
        .filter(
          (image) =>
            image.classList.contains("product-item__primary-image") &&
            image !== newImage
        )
        .forEach((image) => image.setAttribute("hidden", ""));
    }
  }
  _onColorSwatchHovered(event, target) {
    if (target.hasAttribute("data-variant-featured-media")) {
      const newImage = this.primaryImageList.find(
        (image) =>
          image.getAttribute("data-media-id") ===
          target.getAttribute("data-variant-featured-media")
      );
      if (newImage) {
        newImage.setAttribute("loading", "eager");
      }
    }
  }
};
window.customElements.define("did-product-item", DidProductItem);

function smoothScrollTo(event, targetId) {
  event.preventDefault();
  const targetElement = document.getElementById(targetId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth" });
  }
}


// js/custom-element/ui/rid-native-video.js
// Extends Focal's native-video with autoplay failure fallback.
// When autoplay is blocked, falls back to poster + play button if a
// .video-wrapper__poster is present, otherwise toggles banner sections
// via data-section-id (rid-video-banner pattern).
var RidNativeVideo = class extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
    if (this.autoPlay) {
      this.play();
    } else {
      this.addEventListener("click", this.play.bind(this), { once: true });
    }
  }
  get autoPlay() {
    return this.hasAttribute("autoplay");
  }
  play() {
    if (!this.hasLoaded) {
      this._replaceContent();
    }
    this.querySelector("video")
      .play()
      .then(() => {
        // Autoplay succeeded - hide poster if present
        var poster = this.querySelector(".video-wrapper__poster");
        if (poster) {
          poster.style.display = "none";
          this._announceState("Video is now playing");
        }
      })
      .catch((error) => {
        console.warn("Autoplay blocked, falling back", error);
        this._handleAutoplayFailure();
      });
  }
  pause() {
    if (this.hasLoaded) {
      this.querySelector("video").pause();
    }
  }
  // TH 3/11/26 - poster fallback for autoplay failure
  // Banner sections (rid-video-banner, rid-video-banner-deluxe, rid-video-with-text)
  // use data-section-id + enabled/disabled section toggles. Poster-only fallback
  // is for sections without that pattern (e.g. promotion-blocks).
  _handleAutoplayFailure() {
    // If this element uses the banner section toggle pattern, prefer that
    if (this.getAttribute("data-section-id")) {
      this._showHideEnabledDisabledAutoplaySections();
      return;
    }
    var poster = this.querySelector(".video-wrapper__poster");
    if (poster) {
      // Show poster and let user click play button to start video
      poster.style.display = "";
      var playButton = poster.querySelector(".video-wrapper__play-button");
      var target = playButton || poster;
      target.addEventListener("click", () => {
        this.querySelector("video").play().then(() => {
          poster.style.display = "none";
          this._announceState("Video is now playing");
        }).catch(() => {});
      }, { once: true });
      if (playButton) playButton.focus();
      return;
    }
    // Last resort - try section toggle anyway
    this._showHideEnabledDisabledAutoplaySections();
  }
  _announceState(message) {
    var el = this.querySelector(".video-wrapper__sr-status");
    if (!el) {
      el = document.createElement("span");
      el.className = "video-wrapper__sr-status visually-hidden";
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
      this.appendChild(el);
    }
    el.textContent = message;
  }
  _showHideEnabledDisabledAutoplaySections() {
    var screenWidth = window.innerWidth;
    var isMobile = screenWidth <= 740;
    var sectionId = this.getAttribute("data-section-id");
    if (!sectionId) return;

    var findSections = function(pattern) {
      var enabled = document.getElementById(
        "video-banner-autoplay-enabled-section-" + pattern + "-" + sectionId
      );
      var disabled = document.getElementById(
        "video-banner-autoplay-disabled-section-" + pattern + "-" + sectionId
      );
      return { enabled: enabled, disabled: disabled };
    };

    var sections = findSections(isMobile ? "mobile" : "desktop");
    if (!sections.enabled || !sections.disabled) {
      sections = findSections("");
    }

    if (!sections.enabled || !sections.disabled) {
      console.warn("Autoplay fallback sections not found for section ID:", sectionId);
      return;
    }

    sections.enabled.style.display = "none";
    sections.disabled.style.display = "block";
  }

  _replaceContent() {
    var node = this.querySelector("template");
    if (!node) {
      return;
    }
    node = node.content.firstElementChild.cloneNode(true);
    if (!this.hasAttribute("autoplay")) {
      this.innerHTML = "";
    }
    this.appendChild(node);
    node.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });
    node.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });
    this.hasLoaded = true;
  }
};
window.customElements.define("rid-native-video", RidNativeVideo);

var RidProductList = class extends CustomHTMLElement {
  constructor() {
    super();
    this.productListInner = this.querySelector(".product-list__inner");
    this.productItems = Array.from(this.querySelectorAll("rid-product-item"));
  }
  connectedCallback() {
    this.addEventListener("prev-next:prev", this.previous.bind(this));
    this.addEventListener("prev-next:next", this.next.bind(this));
    if (!this.hidden && this.staggerApparition) {
      this._staggerProductsApparition();
    }
  }

  attributeChangedCallback(name) {
    if (name === "hidden") {
      if (this.staggerApparition && !this.hidden) {
        this._staggerProductsApparition();
      }
    }
  }
  get staggerApparition() {
    return this.hasAttribute("stagger-apparition");
  }
  get apparitionAnimation() {
    return (this._animation =
      this._animation ||
      new CustomAnimation(
        new ParallelEffect(
          this.productItems.map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform: [
                  `translateY(${
                    MediaFeatures.prefersReducedMotion()
                      ? 0
                      : window.innerWidth < 1e3
                      ? 35
                      : 60
                  }px)`,
                  "translateY(0)",
                ],
              },
              {
                duration: 600,
                delay: MediaFeatures.prefersReducedMotion()
                  ? 0
                  : 100 * index - Math.min(3 * index * index, 100 * index),
                easing: "ease",
              }
            );
          })
        )
      ));
  }

  previous(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.nextElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip -
        (this.productListInner.clientWidth + columnGap) <=
        0
    );
    this.productListInner.scrollBy({
      left: -(this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }

  next(event) {
    const directionFlip =
        window.themeVariables.settings.direction === "ltr" ? 1 : -1,
      columnGap = parseInt(
        getComputedStyle(this).getPropertyValue("--product-list-column-gap")
      );
    event.target.previousElementSibling.removeAttribute("disabled");
    event.target.toggleAttribute(
      "disabled",
      this.productListInner.scrollLeft * directionFlip +
        (this.productListInner.clientWidth + columnGap) * 2 >=
        this.productListInner.scrollWidth
    );
    this.productListInner.scrollBy({
      left: (this.productListInner.clientWidth + columnGap) * directionFlip,
      behavior: "smooth",
    });
  }
  async _staggerProductsApparition() {
    this.productItems.forEach((item) => (item.style.opacity = 0));
    await this.untilVisible({
      threshold:
        this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
    });
    this.apparitionAnimation.play();
  }
};
__publicField(RidProductList, "observedAttributes", ["hidden"]);
window.customElements.define("rid-product-list", RidProductList);


var RidProductItem = class extends CustomHTMLElement {
  connectedCallback() {
    this.primaryImageList = Array.from(
      this.querySelectorAll(".product-item__primary-image")
    );

    this.currentAnimation = null;

    // If CTA is configured as ATC, intercept delegated clicks on data-role="atc-button" elements
    this.delegate.on(
      'click',
      '[data-role="atc-button"]',
      (event, target) => {
        // Stop navigation from the wrapping anchor (if any)
        event.preventDefault();
        event.stopPropagation();
        this.addSelectedVariantToCart();
      }
    );

    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .color-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );
    this.delegate.on(
      "click",
      ".product-item-meta__swatch-list .block-swatch__radio",
      this._onColorSwatchChanged.bind(this)
    );

    // Initialize state based on any pre-selected swatches (e.g. from browser back navigation)
    this._initializeSwatchState();
  }

  _updateSwatchAvailability = function (
    bandVariants,
    selectedValues,
    matchingVariant,
    width = null
  ) {
    if (!bandVariants) return;
    let bandVariantsArr;
    try {
      bandVariantsArr = JSON.parse(bandVariants);
    } catch (e) {
      console.error("Failed to parse bandVariants", e);
      return;
    }

    if (width) {
      bandVariantsArr = bandVariantsArr.filter((variant) => {
        return (
          variant.option1 === width ||
          variant.option2 === width ||
          variant.option3 === width
        );
      });
      if (bandVariantsArr.length === 0) {
        console.warn("No band variants found for width:", width);
        return;
      }
    }

    const colorSwatchGroup = this.querySelector(
      '.swatch-group-wrapper[data-option-title="Color"]'
    );
    if (!colorSwatchGroup) return;

    colorSwatchGroup
      .querySelectorAll(".color-swatch__item")
      .forEach((swatch) => {
        const swatchValue = swatch.getAttribute("value");
        const swatchContainer = swatch.parentElement;
        const match = bandVariantsArr.find(
          (variant) =>
            variant.option1 === swatchValue ||
            variant.option2 === swatchValue ||
            variant.option3 === swatchValue
        );
        if (match && !match.available) {
          swatchContainer.classList.add("rid-product-item-swatch__unavailable");
        } else {
          swatchContainer.classList.remove(
            "rid-product-item-swatch__unavailable"
          );
        }
      });
  };

  async _onColorSwatchChanged(event, target) {
    let product = this;
    let variants = product.getAttribute("data-product-variants");
    let bandVariants = product.getAttribute("data-band-product-variants");
    let triggersAvailabilityCheck =
      target.getAttribute("triggers_availability_check") === "true" &&
      !!bandVariants;

    try {
      variants = JSON.parse(variants);
    } catch (e) {
      console.error(e);
      return;
    }
    let selectedValues = {};

    const swatchGroup = target.closest(".swatch-group-wrapper");

    if (swatchGroup) {
      swatchGroup.setAttribute(
        "data-selected-value",
        target.getAttribute("value")
      );

      swatchGroup
        .querySelectorAll(".color-swatch__item, .block-swatch__item")
        .forEach((swatch) => {
          swatch.classList.remove("is-selected");
        });

      target.classList.add("is-selected");
      const input = target
        .closest(".color-swatch, .block-swatch")
        ?.querySelector("input");
      if (input) {
        input.checked = true;
        input.focus();
      }
    }

    Array.from(this.querySelectorAll(".swatch-group-wrapper")).forEach(
      (swatchGroup) => {
        let count = 1;
        if (
          swatchGroup.getAttribute("data-option-name") ===
          target.getAttribute("data-option-name")
        ) {
          swatchGroup.setAttribute(
            "data-selected-value",
            target.getAttribute("value")
          );
        }
        selectedValues[swatchGroup.getAttribute("data-option-name")] =
          swatchGroup.getAttribute("data-selected-value") || "";
        count++;
      }
    );
    await this._findMatchingVariantAndSetRelated(
      target,
      selectedValues,
      variants,
      bandVariants,
      triggersAvailabilityCheck
    );
    return;
  }

  // Initialize component state based on pre-selected swatches
  _initializeSwatchState() {
    setTimeout(async () => {
      // Only run if at least one radio is checked (back-nav)
      const anyChecked = this.querySelector('input[type="radio"]:checked');
      if (!anyChecked) {
        return;
      }

      // Build selectedValues for option1/option2/option3 by inspecting swatch groups
      const selectedValues = {};
      const swatchGroups = this.querySelectorAll('.swatch-group-wrapper');

      swatchGroups.forEach((group) => {
        const optionName = group.getAttribute('data-option-name');
        if (!optionName) return;

        // Prefer a checked radio within the group
        let value = '';
        const checked = group.querySelector('input[type="radio"]:checked');
        if (checked) {
          value = checked.value || checked.getAttribute('value') || '';
        }

        // Fallback to explicit data-selected-value stored on the group
        if (!value) {
          value = group.getAttribute('data-selected-value') || '';
        }

        // Final fallback: first swatch item value
        if (!value) {
          const firstSwatchItem = group.querySelector('.color-swatch__item, .block-swatch__item');
          if (firstSwatchItem) {
            value = firstSwatchItem.getAttribute('value') || '';
          }
        }

        selectedValues[optionName] = value || '';
      });

      // Parse variants and optional band variants for resolution
      let variants;
      try {
        variants = JSON.parse(this.getAttribute('data-product-variants'));
      } catch (e) {
        console.error('Failed to parse variants', e);
        return;
      }

      let bandVariants = this.getAttribute('data-band-product-variants');
      try {
        bandVariants = bandVariants ? JSON.parse(bandVariants) : null;
      } catch (e) {
        console.error('Failed to parse band variants', e);
        bandVariants = null;
      }

      await this._findMatchingVariantAndSetRelated(
        null,
        selectedValues,
        variants,
        bandVariants,
        false
      );
    }, 100);
  }

  async _findMatchingVariantAndSetRelated(target, selectedValues, variants, bandVariants = null, triggersAvailabilityCheck = false) {

    let matchingVariant = variants.find(variant => 
      variant.option1 === selectedValues['option1'] &&
      variant.option2 === selectedValues['option2'] &&
      variant.option3 === selectedValues['option3']
    ) || variants.find(variant => 
      variant.option1 === selectedValues['option1'] &&
      variant.option2 === selectedValues['option2']
    ) || variants.find(variant => 
      variant.option1 === selectedValues['option1']
    ) || variants[0];

    if (!matchingVariant) return;


    let matchingVariantId = matchingVariant
      ? matchingVariant.id
      : target.getAttribute("data-variant-id");

    this.setAttribute('data-selected-variant-id', matchingVariantId);

    // Update sold out badges and forms
    const soldOutBadge = this.querySelector("#rid-product-item-sold-out-badge");
    const upsellQuickForm = this.querySelector(".upsell-quick-form");
    const productQuickForm = this.querySelector(".product-item__quick-form");

    if (matchingVariant.available) {
      soldOutBadge?.style.setProperty("display", "none", "important");
      upsellQuickForm?.style.setProperty("visibility", "visible", "important");
      productQuickForm?.style.setProperty("visibility", "visible", "important");
    } else {
      upsellQuickForm?.style.setProperty("visibility", "hidden", "important");
      productQuickForm?.style.setProperty("visibility", "hidden", "important");
      soldOutBadge?.style.setProperty("display", "inline-block", "important");
    }

    Array.from(this.querySelectorAll(`[href*="/products"]`)).forEach((link) => {
      let url;
      if (link.tagName === "A") {
        url = new URL(link.href);
      } else {
        url = new URL(
          link.getAttribute("href"),
          `https://${window.themeVariables.routes.host}`
        );
      }

      url.searchParams.set("variant", matchingVariantId);
      link.setAttribute("href", url.toString());
    });

    if (this.currentAnimation) {
      this.currentAnimation.cancel();
      this.currentAnimation = null;
    }

    const newImage = this.primaryImageList.find((image) => {
      const variantId = image.getAttribute("data-variant-id");
      return variantId === matchingVariantId.toString();
    });

    if (!newImage) {
      console.warn(
        "No matching image found for variant ID:",
        matchingVariantId
      );
      return;
    }

    newImage.setAttribute("loading", "eager");
    const onImageLoaded = newImage.complete
      ? Promise.resolve()
      : new Promise((resolve) => (newImage.onload = resolve));
    await onImageLoaded;
    newImage.removeAttribute("hidden");
    this.setAttribute("data-variant-image-src", newImage.src);
    let properties = {};
    if (
      Array.from(newImage.parentElement.classList).some((item) =>
        [
          "aspect-ratio--short",
          "aspect-ratio--tall",
          "aspect-ratio--square",
        ].includes(item)
      )
    ) {
      properties = [
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          transform: "translate(calc(-50% - 20px), -50%)",
          zIndex: 1,
          offset: 0,
        },
        {
          clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
          transform: "translate(calc(-50% - 20px), -50%)",
          zIndex: 1,
          offset: 0.3,
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          transform: "translate(-50%, -50%)",
          zIndex: 1,
          offset: 1,
        },
      ];
    } else {
      properties = [
        {
          clipPath: "polygon(0 0, 0 0, 0 100%, 0% 100%)",
          transform: "translateX(-20px)",
          zIndex: 1,
          offset: 0,
        },
        {
          clipPath: "polygon(0 0, 20% 0, 5% 100%, 0 100%)",
          transform: "translateX(-20px)",
          zIndex: 1,
          offset: 0.3,
        },
        {
          clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
          transform: "translateX(0px)",
          zIndex: 1,
          offset: 1,
        },
      ];
    }

    this.currentAnimation = newImage.animate(properties, {
      duration: 500,
      easing: "ease-in-out",
    });

    try {
      await this.currentAnimation.finished;
    } catch {
      // Animation was cancelled - this is expected when clicking rapidly
    }

    this.primaryImageList
      .filter(
        (image) =>
          image.classList.contains("product-item__primary-image") &&
          image !== newImage
      )
      .forEach((image) => image.setAttribute("hidden", ""));
    triggersAvailabilityCheck &&
      this._updateSwatchAvailability(
        bandVariants,
        selectedValues,
        matchingVariant,
        target.getAttribute("value")
      );
  }
  
  // Add currently selected variant to cart (used when CTA is configured as ATC)
  async addSelectedVariantToCart() {
    try {
      const ridProductItemId = this.getAttribute('id') || 'unknown';
      const variantIdAttr = this.getAttribute('data-selected-variant-id');
      let variantId = variantIdAttr || null;

      if (!variantId) {
        const visibleImage = this.primaryImageList.find(img => !img.hasAttribute('hidden')) || this.primaryImageList[0];
        variantId = visibleImage ? visibleImage.getAttribute('data-variant-id') : null;
      }

      if (!variantId) {
        console.error('RidProductItem: No selected variant id found for ATC CTA');
        return;
      }

      const body = {
        quantity: 1,
        id: Number(variantId)
      };

      // TH 12/4/25 - thanks i hate this, but it's the fix we need given bandana bundle cart transformer requirements.
      if (ridProductItemId.includes('bandana')) {
        let guid = crypto.randomUUID();
        body.properties = {
          '_bandana-bundle-id': String(guid),
        };
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      
      if (!response.ok) {
        const responseJson = await response.json();
        
        document.documentElement.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: "error",
              error: responseJson["description"] || `Failed to add item to cart.`,
            },
          })
        );
        return;
      }

      window.location.href = `/cart`;
    } catch (e) {
      console.error('RidProductItem: Error adding selected variant to cart', e);
    }
  }
};
window.customElements.define("rid-product-item", RidProductItem);

// js/custom-element/ui/rid-order-now.js
var RidOrderNow = class extends HTMLElement {
  constructor() {
    super();
    this.preorderDate = this.getAttribute("data-pre-order-date");
    this.orderNowTextData = document.getElementById("order-now-text-data");
    this.presetText = this.orderNowTextData?.getAttribute(
      "data-order-now-text"
    );
    this.init();
  }

  async init() {
    // Find both text elements - we need to handle both regular and mini-cart versions
    this.textElements = [
      this.querySelector("#order-now-snippet-text"),
      this.querySelector("#order-now-mini-cart-snippet-text"),
    ].filter(Boolean); // Remove any null elements

    if (this.textElements.length === 0) {
      console.error("No order now text elements found");
      return;
    }

    if (this.preorderDate) {
      this.handlePreorderDate();
    } else if (this.presetText) {
      this.handlePresetText();
    } else {
      await this.handleDynamicShipping();
    }
  }

  handlePreorderDate() {
    const [year, month, day] = this.preorderDate.split("-");
    const dateObj = new Date(year, month - 1, day);
    const options = { year: "numeric", month: "long", day: "numeric" };
    const formattedDate = dateObj.toLocaleDateString("en-US", options);

    const text = `Order now and it ships <b>${formattedDate}.</b>`;
    this.updateAllTextElements(text);

    const fastMessage = this.querySelector("#get-it-fast-message");
    if (fastMessage) {
      fastMessage.style.display = "none";
    }

    // if preorder date is after 12/19/25 hide #additional-order-now-text - re: holiday messaging.
    const additionalText = this.querySelector("#additional-order-now-text");
    const cutOffDate = new Date(2025, 11, 19);
    if (additionalText && dateObj > cutOffDate) {
      additionalText.style.display = "none";
    }

    this.style.visibility = "visible";
  }

  handlePresetText() {
    this.updateAllTextElements(this.presetText);
    this.style.visibility = "visible";
  }

  async handleDynamicShipping() {
    try {
      const response = await fetch(
        "https://dogid.com/pages/shipping_date_v2.json"
      );
      const responseJson = await response.json();
      const data = JSON.parse(responseJson.page.body_html.replace(/'/g, '"'));

      const now = new Date();
      const cutoffDateTime = new Date(data.cutoffDateTime);
      let shipsWhen;
      let expectedShipDate;

      if (now < cutoffDateTime) {
        expectedShipDate = new Date(data.preCutoffShipDate);
      } else {
        expectedShipDate = new Date(data.postCutoffShipDate);
      }

      const normalizeDate = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
      };

      const normalizedExpectedShipDate = normalizeDate(expectedShipDate);
      const normalizedNow = normalizeDate(now);
      const dayDifference = Math.ceil(
        (normalizedExpectedShipDate - normalizedNow) / (1000 * 60 * 60 * 24)
      );

      if (dayDifference === 0) {
        shipsWhen = "today";
      } else if (dayDifference === 1) {
        shipsWhen = "tomorrow";
      } else if (dayDifference > 6) {
        shipsWhen = `in ${dayDifference} days`;
      } else {
        shipsWhen = expectedShipDate.toLocaleString("en-US", {
          weekday: "long",
        });
      }

      const timeDifferenceMs = cutoffDateTime - now;
      const remainingHours = Math.floor(timeDifferenceMs / (1000 * 60 * 60));
      const remainingMinutes = Math.floor(
        (timeDifferenceMs % (1000 * 60 * 60)) / (1000 * 60)
      );
      const isDeadlineApproaching = remainingHours < 6;

      let text =
        isDeadlineApproaching === false
          ? `Order <b>now</b> and it ships <b>${shipsWhen}!</b>`
          : remainingHours > 0 || remainingMinutes > 0
          ? `Order within <b>${
              remainingHours > 0
                ? `${remainingHours} ${remainingHours === 1 ? "hour" : "hours"}`
                : ""
            } ${
              remainingMinutes > 0
                ? `${remainingMinutes} ${
                    remainingMinutes === 1 ? "minute" : "minutes"
                  }`
                : ""
            }</b> and it ships <b>${shipsWhen}!</b>`
          : `Order now and it ships <b>${shipsWhen}!</b>`;

      if (this.orderNowTextData) {
        this.orderNowTextData.setAttribute("data-order-now-text", text);
      }

      this.updateAllTextElements(text);
      this.style.visibility = "visible";
    } catch (e) {
      console.error("Error fetching shipping information:", e);
    }
  }

  updateAllTextElements(text) {
    this.textElements.forEach((element) => {
      element.innerHTML = text;
    });
  }
};

window.customElements.define("rid-order-now", RidOrderNow);


// js/custom-element/section/product/rid-product-media.js
var RidProductMedia = class extends CustomHTMLElement {
  async connectedCallback() {
    this.mainCarousel = this.querySelector("flickity-carousel");
    if (this.hasAttribute("reveal-on-scroll")) {
      this._setupVisibility();
    }
    if (this.mainCarousel.childElementCount === 1) {
      return;
    }
    this.selectedVariantMediaId = null;
    this.viewInSpaceElement = this.querySelector("[data-shopify-model3d-id]");
    this.zoomButton = this.querySelector(".product__zoom-button");
    this.product = await ProductLoader.load(
      this.getAttribute("product-handle")
    );
    const form = document.getElementById(this.getAttribute("form-id"));
    form?.addEventListener("variant:change", this._onVariantChanged.bind(this));
    this.mainCarousel.addEventListener("model:played", () =>
      this.mainCarousel.setDraggable(false)
    );
    this.mainCarousel.addEventListener("model:paused", () =>
      this.mainCarousel.setDraggable(true)
    );
    this.mainCarousel.addEventListener("video:played", () =>
      this.mainCarousel.setDraggable(false)
    );
    this.mainCarousel.addEventListener("video:paused", () =>
      this.mainCarousel.setDraggable(true)
    );
    this.mainCarousel.addEventListener(
      "flickity:ready",
      this._onFlickityReady.bind(this)
    );
    this.mainCarousel.addEventListener(
      "flickity:slide-changed",
      this._onFlickityChanged.bind(this)
    );
    this.mainCarousel.addEventListener(
      "flickity:slide-settled",
      this._onFlickitySettled.bind(this)
    );
    this._onFlickityReady();
  }
  get thumbnailsPosition() {
    return window.matchMedia(window.themeVariables.breakpoints.pocket).matches
      ? "bottom"
      : this.getAttribute("thumbnails-position");
  }
  async _setupVisibility() {
    await this.untilVisible();
    const flickityInstance = await this.mainCarousel.flickityInstance,
      image = flickityInstance
        ? flickityInstance.selectedElement.querySelector("img")
        : this.querySelector(".product__media-image-wrapper img"),
      prefersReducedMotion = MediaFeatures.prefersReducedMotion();
    await imageLoaded(image);
    const animation = new CustomAnimation(
      new ParallelEffect([
        new CustomKeyframeEffect(
          image,
          {
            opacity: [0, 1],
            transform: [`scale(${prefersReducedMotion ? 1 : 1.1})`, "scale(1)"],
          },
          { duration: 500, easing: "cubic-bezier(0.65, 0, 0.35, 1)" }
        ),
        new ParallelEffect(
          Array.from(
            this.querySelectorAll(".product__thumbnail-item:not(.is-filtered)")
          ).map((item, index) => {
            return new CustomKeyframeEffect(
              item,
              {
                opacity: [0, 1],
                transform:
                  this.thumbnailsPosition === "left"
                    ? [
                        `translateY(${prefersReducedMotion ? 0 : "40px"})`,
                        "translateY(0)",
                      ]
                    : [
                        `translateX(${prefersReducedMotion ? 0 : "50px"})`,
                        "translateX(0)",
                      ],
              },
              {
                duration: 250,
                delay: prefersReducedMotion ? 0 : 100 * index,
                easing: "cubic-bezier(0.75, 0, 0.175, 1)",
              }
            );
          })
        ),
      ])
    );
    this._hasSectionReloaded ? animation.finish() : animation.play();
  }
  async _onVariantChanged(event) {
    const variant = event.detail.variant;
    const featuredMediaId = event.detail.variant["featured_media"]
      ? event.detail.variant["featured_media"]["id"]
      : null;

    let allowedIds = [];
    if (featuredMediaId) allowedIds.push(featuredMediaId);

    const filteredMediaIds = [];
    this.product["media"].forEach((media) => {
      let matchMedia2 =
        variant["featured_media"] &&
        media["id"] === variant["featured_media"]["id"];
      if (media["alt"]?.includes("#")) {
        if (!matchMedia2) {
          const altParts = media["alt"].split("#"),
            mediaGroupParts = altParts.pop().split("_");
          this.product["options"].forEach((option) => {
            if (
              option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()
            ) {
              if (
                variant["options"][option["position"] - 1].toLowerCase() !==
                mediaGroupParts[1].trim().toLowerCase()
              ) {
                filteredMediaIds.push(media["id"]);
              }
            }
          });
        }
      }
    });

    let currentlyFilteredIds = [
      ...new Set(
        Array.from(this.querySelectorAll(".is-filtered[data-media-id]")).map(
          (item) => parseInt(item.getAttribute("data-media-id"))
        )
      ),
    ];
    if (allowedIds.length > 0) {
      const selectedMediaId = variant["featured_media"]
        ? variant["featured_media"]["id"]
        : this.product["media"]
            .map((item) => item.id)
            .filter((item) => !filteredMediaIds.includes(item))[0];
      const flickityInstance = await this.mainCarousel.flickityInstance;
      flickityInstance.destroy();
      Array.from(this.querySelectorAll("[data-media-id]")).forEach((item) => {
        if (item.hasAttribute("is-featured-media")) {
          allowedIds.includes(parseInt(item.getAttribute("data-media-id"))) ||
            allowedIds.push(parseInt(item.getAttribute("data-media-id")));
        }
        item.classList.toggle(
          "is-filtered",
          !allowedIds.includes(parseInt(item.getAttribute("data-media-id")))
        );
        item.classList.toggle(
          "is-selected",
          selectedMediaId === parseInt(item.getAttribute("data-media-id"))
        );
        item.classList.toggle(
          "is-initial-selected",
          selectedMediaId === parseInt(item.getAttribute("data-media-id"))
        );
      });
      this.mainCarousel.reload();
    } else {
      if (
        !event.detail.variant["featured_media"] ||
        this.selectedVariantMediaId ===
          event.detail.variant["featured_media"]["id"]
      ) {
        return;
      }
      this.mainCarousel.select(
        `[data-media-id="${event.detail.variant["featured_media"]["id"]}"]`
      );
    }
    this.selectedVariantMediaId = event.detail.variant["featured_media"]
      ? event.detail.variant["featured_media"]["id"]
      : null;
  }
  async _onFlickityReady() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    if (
      ["video", "external_video"].includes(
        flickityInstance.selectedElement.getAttribute("data-media-type")
      ) &&
      this.hasAttribute("autoplay-video")
    ) {
      flickityInstance.selectedElement.firstElementChild.play();
    }
  }
  async _onFlickityChanged() {
    const flickityInstance = await this.mainCarousel.flickityInstance;
    flickityInstance.cells.forEach((item) => {
      if (
        ["external_video", "video", "model"].includes(
          item.element.getAttribute("data-media-type")
        )
      ) {
        item.element.firstElementChild.pause();
      }
    });
  }
  async _onFlickitySettled() {
    const flickityInstance = await this.mainCarousel.flickityInstance,
      selectedSlide = flickityInstance.selectedElement;
    if (this.zoomButton) {
      this.zoomButton.hidden =
        selectedSlide.getAttribute("data-media-type") !== "image";
    }
    if (this.viewInSpaceElement) {
      this.viewInSpaceElement.setAttribute(
        "data-shopify-model3d-id",
        this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id")
      );
    }
    switch (selectedSlide.getAttribute("data-media-type")) {
      case "model":
        this.viewInSpaceElement.setAttribute(
          "data-shopify-model3d-id",
          selectedSlide.getAttribute("data-media-id")
        );
        selectedSlide.firstElementChild.play();
        break;
      case "external_video":
      case "video":
        if (this.hasAttribute("autoplay-video")) {
          selectedSlide.firstElementChild.play();
        }
        break;
    }
  }
};
window.customElements.define("rid-product-media", RidProductMedia);

// js/custom-element/section/discount/notification.js
var DiscountNotification = class extends CustomHTMLElement {
    connectedCallback() {

      document.addEventListener("discount-notification:show", this._onShow.bind(this));
  
      this.delegate.on("click", '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.hidden = true;
      });
  
      this.addEventListener("mouseenter", this.stopTimer.bind(this));
      this.addEventListener("mouseleave", this.startTimer.bind(this));
      window.addEventListener("pagehide", () => (this.hidden = true));
    }
  
    set hidden(value) {
      if (!value) {
        this.startTimer();
      } else {
        this.stopTimer();
      }
      this.toggleAttribute("hidden", value);
    }
  
    get isInsideDrawer() {
      return this.classList.contains("discount-notification--drawer");
    }
  
    stopTimer() {
      clearTimeout(this._timeout);
    }
  
    startTimer() {
      this._timeout = setTimeout(() => (this.hidden = true), 3000);
    }
  
    _onShow(event) {
  
      if (this.isInsideDrawer && !this.closest(".drawer")?.open) {
        console.warn("Drawer is closed. Notification not displayed.");
        return;
      }
  
      event.stopPropagation();
  
      let closeButtonHtml = "";
      if (!this.isInsideDrawer) {
        closeButtonHtml = `
          <button class="discount-notification__close tap-area" data-action="close" style="right: 24px !important;">
            <span class="visually-hidden">${window.themeVariables.strings.accessibilityClose}</span>
            <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
              <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
            </svg>
          </button>
        `;
      }
  
      this.innerHTML = event.detail.status === "success"
        ? `<div class="discount-notification__wrapper heading heading--small">Success! Discount applied. ${closeButtonHtml}</div>`
        : `<div class="discount-notification__wrapper discount-notification--error heading heading--small">Error: ${event.detail.error} ${closeButtonHtml}</div>`;
  
      this.hidden = false;
    }
  
    showNotification(status = "success", error = "") {
      this._onShow({ detail: { status, error } });
    }
  };
  
  window.customElements.define("discount-notification", DiscountNotification);

var DidFreeGiftFab = class extends CustomHTMLElement {
  connectedCallback() {
    this._variantId = parseInt(this.getAttribute('data-free-variant-id'), 10);
    this._productId = parseInt(this.getAttribute('data-free-product-id'), 10);
    this._qualifyingIds = (this.getAttribute('data-qualifying-ids') || '')
      .split(',')
      .map(function(id) { return parseInt(id.trim(), 10); })
      .filter(function(id) { return !isNaN(id); });
    this._delta = parseInt(this.getAttribute('data-delta'), 10) || 0;
    this._productTitle = this.getAttribute('data-product-title') || '';

    this._boundOnCartUpdated = this._onCartUpdated.bind(this);
    this._boundOnClickAdd = this._onClickAdd.bind(this);
    this._boundOnClickDismiss = this._onClickDismiss.bind(this);
    document.documentElement.addEventListener('cart:updated', this._boundOnCartUpdated);
    this.querySelector('[data-fab-btn]').addEventListener('click', this._boundOnClickAdd);
    const dismissBtn = this.querySelector('[data-fab-dismiss]');
    if (dismissBtn) dismissBtn.addEventListener('click', this._boundOnClickDismiss);

    if (this._isDeclined()) this._hide();
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener('cart:updated', this._boundOnCartUpdated);
    const fabBtn = this.querySelector('[data-fab-btn]');
    if (fabBtn) fabBtn.removeEventListener('click', this._boundOnClickAdd);
    const dismissBtn = this.querySelector('[data-fab-dismiss]');
    if (dismissBtn) dismissBtn.removeEventListener('click', this._boundOnClickDismiss);
  }

  _onCartUpdated(event) {
    if (!event.detail || !event.detail.cart) return;
    this._checkCart(event.detail.cart);
  }

  _checkCart(cart) {
    const items = cart.items || [];
    let qualifyingQty = 0;
    let freeGiftQty = 0;

    // Count qualifying products and free gift in the cart
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (this._qualifyingIds.indexOf(item.product_id) !== -1) qualifyingQty += item.quantity;
      if (item.product_id === this._productId) freeGiftQty += item.quantity;
    }

    this._delta = Math.max(0, qualifyingQty - freeGiftQty);

    if (this._delta > 0 && freeGiftQty === 0) {
      const label = this._delta + ' FREE ' + this._productTitle + (this._delta === 1 ? '' : 's');
      const heading = this.querySelector('[data-fab-heading]');
      if (heading) heading.textContent = label;
      this.setAttribute('aria-label', label);
      this._show();
    } else {
      this._hide();
    }
  }

  _isDeclined() {
    try { return !!sessionStorage.getItem('did-free-gift-fab-declined-' + this._variantId); } catch (e) { return false; }
  }

  _show() {
    if (this._isDeclined()) return;
    this.removeAttribute('hidden');
    this.setAttribute('aria-hidden', 'false');
  }

  _hide() {
    if (this.contains(document.activeElement)) document.activeElement.blur();
    this.setAttribute('hidden', '');
    this.setAttribute('aria-hidden', 'true');
  }

  _onClickDismiss() {
    try { sessionStorage.setItem('did-free-gift-fab-declined-' + this._variantId, '1'); } catch (e) {}
    this._hide();
  }

  _onClickAdd() {
    const btn = this.querySelector('[data-fab-btn]');
    if (!btn || btn.getAttribute('aria-busy') === 'true' || this._delta <= 0) return;

    btn.setAttribute('aria-busy', 'true');
    btn.setAttribute('disabled', '');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this._variantId, quantity: this._delta })
    })
      .then(function(response) {
        if (!response.ok) {
          return response.json().then(function(json) {
            throw new Error(json.description || 'Failed to add to cart.');
          });
        }
        if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
          return;
        }
        this._hide();
        return fetch(window.Shopify.routes.root + 'cart.js').then(function(r) { return r.json(); });
      }.bind(this))
      .then(function(cartData) {
        if (!cartData) return;
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: { cart: cartData }
        }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { cart: cartData, openMiniCart: window.themeVariables.settings.cartType === 'drawer' }
        }));
      })
      .catch(function(error) {
        console.error('DidFreeGiftFab:', error.message);
        fetch(window.Shopify.routes.root + 'cart.js')
          .then(function(r) { return r.json(); })
          .then(this._checkCart.bind(this))
          .catch(function(e) { console.warn('DidFreeGiftFab: cart re-fetch failed', e); });
      }.bind(this))
      .finally(function() {
        btn.removeAttribute('disabled');
        btn.setAttribute('aria-busy', 'false');
      });
  }
};

window.customElements.define('did-free-gift-fab', DidFreeGiftFab);

// ------------------------------------------------------------------
// RID FREE SHIPPING BAR
// ------------------------------------------------------------------
// TH 5/26/26 - Replaces Focal's <free-shipping-bar> on our cart surfaces.
// The threshold is stored in shop currency (data-shop-threshold-cents); we convert it to the
// buyer's presentment currency via Shopify.currency.rate so the bar matches what checkout enforces.
// Liquid renders an initial shop-currency state; we only correct it on load when rate !== 1, so
// shop-currency (e.g. USD) buyers keep the pristine Liquid render with no flash. Owns both the
// --progress width and the "spend X more" text (Focal's element only did progress), and uses
// Intl.NumberFormat for the remaining amount because formatMoney() only knows the shop money format.
var RidFreeShippingBar = class extends HTMLElement {
  connectedCallback() {
    this._boundOnCartUpdated = this._onCartUpdated.bind(this);
    document.documentElement.addEventListener('cart:updated', this._boundOnCartUpdated);
    if (this._rate() !== 1) {
      this._render(this._seededTotalCents());
    }
  }

  disconnectedCallback() {
    document.documentElement.removeEventListener('cart:updated', this._boundOnCartUpdated);
  }

  _rate() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) ? parseFloat(window.Shopify.currency.rate) : 1;
  }

  _presentmentThresholdCents() {
    return (parseFloat(this.getAttribute('data-shop-threshold-cents')) || 0) * this._rate();
  }

  _seededTotalCents() {
    return parseFloat(this.getAttribute('data-cart-total-cents')) || 0;
  }

  _onCartUpdated(event) {
    if (!event.detail || !event.detail.cart || !event.detail.cart.items) return;
    var cart = event.detail.cart;
    var shippingTotal = cart.items
      .filter(function (item) { return item.requires_shipping; })
      .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
    var cartLevelDiscount = (cart.cart_level_discount_applications || [])
      .reduce(function (sum, discount) { return sum + discount.total_allocated_amount; }, 0);
    this._render(shippingTotal - cartLevelDiscount);
  }

  _render(totalCents) {
    totalCents = Math.max(0, totalCents); // a full cart-level discount can drive this negative
    var threshold = this._presentmentThresholdCents();
    this.style.setProperty('--progress', threshold > 0 ? Math.min(totalCents / threshold, 1) : 0);

    var textEl = this.querySelector('.shipping-bar__text');
    if (!textEl) return;

    if (threshold > 0 && totalCents >= threshold) {
      textEl.textContent = this.getAttribute('data-free-text') || '';
      return;
    }

    var remaining = threshold - totalCents;
    var currencyCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    var formatted;
    try {
      formatted = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }).format(remaining / 100);
    } catch (e) {
      formatted = (remaining / 100).toFixed(2);
    }
    textEl.innerHTML = (this.getAttribute('data-remaining-template') || '').replace('%%AMT%%', formatted);
  }
};

window.customElements.define('rid-free-shipping-bar', RidFreeShippingBar);

// ------------------------------------------------------------------
// MOBILE NAVIGATION - DISABLE STAGGERED APPARITION ANIMATION
// ------------------------------------------------------------------
// TH 05-21-26 - Disable MobileNavigation staggered apparition animation.
// The Focal default animates each .mobile-nav__item[data-level="1"] with translateX(-40px) to 0
// over 300ms each, staggered ~120ms apart, with the footer last (~1.4s after drawer open).
// During the translateX phase, the hit-test box is shifted off its visual position, creating
// a dead-click window where users tap visible links that don't fire. The drawer's own 600ms
// CSS slide-in remains for entrance polish; per-item stagger is removed.
// Implemented as a prototype-getter override rather than editing theme.js.
window.customElements.whenDefined('mobile-navigation').then(function() {
  var MobileNav = window.customElements.get('mobile-navigation');
  if (MobileNav) {
    Object.defineProperty(MobileNav.prototype, 'apparitionAnimation', {
      get: function() { return null; },
      configurable: true
    });
  }
});

// ------------------------------------------------------------------
// PDP UPSELL DRAWER "INCLUDE" CTA
// ------------------------------------------------------------------
document.addEventListener('click', function (event) {
  var btn = event.target.closest('.js-did-upsell-drawer-cta');
  if (!btn) return;
  var checkbox = document.getElementById(btn.dataset.didUpsellCheckboxId);
  if (checkbox && !checkbox.checked) {
    checkbox.checked = true;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }
  var drawer = btn.closest('drawer-content');
  if (drawer) drawer.open = false;
});